import { NgRedux, select } from '@angular-redux/store';
import { Component, OnInit } from '@angular/core';
import { Actions, ChangePickupTypeRequest, IAppState, PickupTypeMetadata, UserOrderInfo } from '@app/core/redux/stores';
import { ConfirmModalService, ModalService, OverlayService, ProxyService } from '@app/core/services';
import { LocationConstants } from '@app/features/location/constants';
import { ApiRoutes } from '@app/shared/models/configs/api.endpoints';
import _ from 'lodash';
import { Observable, Subscription } from 'rxjs';
import { CheckInService } from '../../services/checkin.service';
import { PickupTimeService } from '../../services/pickup-time.service';

@Component({
  selector: 'app-change-order-pickup-type',
  templateUrl: './change-order-pickup-type.component.html',
  styleUrls: ['./change-order-pickup-type.component.less']
})
export class ChangeOrderPickupTypeComponent implements OnInit {
  @select(appState => appState.submittedOrder) submittedOrder: Observable<UserOrderInfo>;
  @select((appState) => appState.auth.isLoggedIn)  isLoggedIn?: Observable<boolean>;
  pickupTypes: PickupTypeMetadata[];
  protected order: UserOrderInfo;
  pickupType= null;
  isLoading = false;  
  isUserLoggedIn: boolean;
  pickupMethodSet: boolean = false;
  public pickupmethod: number;
  constructor(private checkIn: CheckInService, 
              private confirmModalService: ConfirmModalService,
              private pickupTimeService: PickupTimeService,
              private modalService: ModalService,
              private overlayService: OverlayService,
              private http: ProxyService,
              private ngRedux: NgRedux<IAppState>) {
                this.submittedOrder.subscribe(succ => {
                  this.order = _.cloneDeep(succ) as UserOrderInfo;
                });
                this.isLoggedIn.subscribe(
                  (auth) => {
                    this.isUserLoggedIn = auth ? auth : false;
                  });
               }

  ngOnInit(): void {
    this.pickupMethodSet = false;    
    this.pickupTypes =  LocationConstants.PickupTypeMetaDataList.filter(p => this.checkIn?.checkInOption?.alternatePickupTypes?.includes(p.pickupType));
    if(!this.pickupTypes?.length) {
      this.modalService.hideModal();
      setTimeout(() => {
        this.confirmModalService.show(
          'No Pickup Method available',
          '',
          'Unfortunately the pickup method can not be changed',
          'OK, Got It',
          '',
          '',
          true,
          'close'
        );
      }, 100);
    }
  }

  selectPickupType() {
    const changePickupTypeRequest: ChangePickupTypeRequest = {pickupType: this.pickupmethod};
    const endpoint = (this.isUserLoggedIn ? ApiRoutes.ORDER_STATUS + this.order.orderNumber  : '/meals/orders/' + this.order.orderNumber + '/' + this.order.guid) + '/pickup-type';
    this.http.httpPut(endpoint, changePickupTypeRequest).subscribe(success => {
      this.pickupTypeSelected(true, changePickupTypeRequest);
    }, error => {
      this.pickupTypeSelected(false, changePickupTypeRequest);
    });
  }
  cancel() {
    this.modalService.hideModal();
  }
  private pickupTypeSelected(isSuccessful: boolean, pickupType: ChangePickupTypeRequest) {
    if(isSuccessful) {
      this.order.pickupType = pickupType.pickupType;
    }
    this.ngRedux.dispatch({ type: Actions.SUBMITTEDORDER, data: this.order });
    this.overlayService.displayOverlay(
      isSuccessful ? 'Your pickup method has been changed.' :'Your pickup method could not be changed'
    );
    this.modalService.hideModal();
  }
  getPickupTypeIconClass(pickupType: number) {
    return this.pickupTypes.find(p => p.pickupType === pickupType).iconClass;
  }
  getPickupTypeLabelText(pickupType: number) {
    const metaData = LocationConstants.PickupTypeMetaDataList.find(p => p.pickupType === pickupType);
    return metaData.labelText ? metaData.labelText : metaData.text;
  }
  public pickUpMethodChange(method) {
    this.pickupMethodSet = method;
  }
}
